/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, ajax } from '../../twd'
import toSearchParams from './to-search-params'

export default ({errors, values}) => {

    const timerId = React.useRef()
    const lastBody = React.useRef()
    const lastAbort = React.useRef()
    const hasError = Object.keys(errors).length>0
    const buttonRef = React.useRef()

    React.useEffect(() => {

        if (timerId.current) {
            clearInterval(timerId.current)
            timerId.current = 0
        }

        timerId.current = setTimeout(async () => {
            if (hasError) return

            let p = Object.assign({
                searchType:'offers',
                pageNumber:1,
                persistToPreviousSearches: false,
                marketCheckRequired: false,
            }, toSearchParams(Object.assign({isSubmit:true}, values)), {
                resultsPerPage: 1,
                sort: [{
                    field: 'holdMaturitySortDt',
                    direction: 'ASC'
                }]
            })

            let body = JSON.stringify(p)
            if (lastBody.current === body) return

            lastBody.current = body

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let { data, abort } = await ajax({
                    url:'/esb/portfolio/offersearch/getHitCount',
                    method: 'POST',
                    body
                })

                updateText(null)
                lastAbort.current = abort
                let { resultSetCount } = await data
                lastAbort.current = null
                updateText(resultSetCount)

            } catch(e) {
                updateText(null)
            }
        }, 1000)

        return () => {
            if (lastAbort.current) lastAbort.current()
            if (timerId.current) clearInterval(timerId.current)
        }
    })

    const updateText = (count) => {
        if (!buttonRef.current) return
        if (count===null || count===undefined) {
            buttonRef.current.innerHTML = 'View results'
            return
        }

        let s = `View (${fmt.count(count)}) results`
        buttonRef.current.innerHTML = s
    }

    return <button
        data-name="advanced-screener-view-results-button"
        ref={buttonRef}
        type="submit"
        disabled={hasError}
        className="btn btn-primary btn-block">
            View results
        </button>
}



// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/submit-button.js